
import __event from '../event';
/**
 * this.data Array
 * [{
 *  type	整型	0表示初始化数据，1表示音视频统计数据，2为事件，此处填1
 *  counterId	整型	递增ID
 *  appCpuUsage	整型	应用的cpu占用率，0-100
 *  systemCpuUsage	整型	系统的cpu占用率，0-100
 *  streamType	整型	流类型,0为正常音视频流，1为共享桌面流
 *  subMemName	字符串	对方的memName，isPub为false有效
 *  subMemId	字符串	对方的memId，isPub为fasle有效
 *  sId	字符串	流ID
 *  rtcId	字符串	rtcId，sdk生成的
 *  isPub	BOOL	是否上传者
 *  audioInputLevel	整型	采集音量大小，isPub为true时有效
 *  time	整型	时间戳，utc时间，单位毫秒
 *  vKBps	整型	视频码率，单位kbps，isPub为ture时为上行，false时为下行
 *  vFps	整型	视频帧率，单位fps，isPub为ture时为上行，false时为下行
 *  vW	整型	视频宽，isPub为ture时为上行，false时为下行
 *  vH	整型	视频高，isPub为ture时为上行，false时为下行
 *  vP	整型	视频包计数，isPub为ture时为上行，false时为下行
 *  vPL	整型	视频包丢失数，isPub为ture时为上行，false时为下行
 *  vPLR	整型	视频丢包率，0-100，isPub为ture时为上行，false时为下行
 *  aKBps	整型	音频码率，单位kbps，isPub为ture时为上行，false时为下行
 *  aP	整型	音频包计数，isPub为ture时为上行，false时为下行
 *  aPL	整型	音频包丢失计数，isPub为ture时为上行，false时为下行
 *  aPLR	整型	音频丢包率，0-100，isPub为ture时为上行，false时为下行
 *  vCodec	字符串	视频编码
 *  aCodec	字符串	音频编码
 * }]
 */
class UploadStats {
    constructor(emedia) {
        this.emedia = emedia; // emedia 对象 只可读

        this.streams = [];
        this._intervals_get = null; // 收集数据的 interval
        this._intervals_upload = null; // 上报数据的 interval，从这里取数据上报 --- 唯一的
        this.data = [];
        this.counterId = 1;

        
        this.prev_obj = {
            //  store video、audio of prev package package_lost; sent and receive ...
            /*
            * {
                [sid]: {
                    time:,
                    audio: {
                        bytes:56780,
                        packets: 890,
                        packetsLost: 2

                    },
                    video: {
                        bytes:56780,
                        packets: 890,
                        packetsLost: 2
                    }
                }
            }
            */
        }

        this.sessionId = null;

        this.network_quality_obj = {
            /**
             * [sId]: {
             *  RTT: { time, value }
             *  aPLR: { time, value}
             *  vPLR: { time, value}
             *  disconnect: { time }
            //  *  status: 0 | 1 | 2 , 0: 没有数据，1:网络不好 2: 网络好 
             * }
            */
        }
        this.network_quality_threshold = { // 网络质量差的阈值 , 连续 time 内大于 value
            RTT: {
               time: 8000, // ms
               value: 500 // ms
            },
            aPLR: {
               time: 8000, // ms
               value: 18 // %
            },
            vPLR: {
               time: 8000, // ms
               value: 23 // %
            },
            disconnect: { time: 5000 } // ms
        },

        this.re_timer_count = 0; // 重连次数

    }
    _get_url() {

        let url = '';
        let { current } =  this.emedia.useCurrentXService;

        if(!current) {
            return url
        }

        let { qoeUpUrl, memName } = current.ticket;
            memName = memName.split('_')[1];

        let { appkey } = emedia.config;
        let orgName = appkey.split('#')[0],
            appName = appkey.split('#')[1];

        let ts = new Date().getTime();
        let access_token = emedia.mgr.identityToken;

        url = `${qoeUpUrl}?orgName=${orgName}&appName=${appName}&memName=${memName}&ts=${ts}&access_token=${access_token}`;

        return url

    }


    connect_ws() { // 创建websocket长连接

        let url = this._get_url()
        if(!url) {
            console.error('upload stats not have ws url');
            return
        }

        var socket = new WebSocket(url);
        let _this = this;
        socket.onopen = () => {
            console.log('upload stats ws connected');
            _this.ws_connected = true;
            _this.socket = socket;

            if(_this.re_connect) {// 如果是重连的
                console.log('has Reconnectioned');

                console.log('before joinS');
                if(_this.sessionId) {
                    console.log('have sessID');
                    _this.join_success(_this.sessionId)
                }
            }
        }

        socket.onclose = (error) => {
            _this.stop();
            _this.ws_connected = false;
            console.error('upload stats ws close');

            if(navigator.onLine ) _this.reconnection(); // 只在有网的状态下重连
        }

        socket.message = (evt) => {
            console.log('upload stats ws recv msg', evt);
        }

        socket.onerror = (error) => {
            console.error('upload stats ws error', error);
        }

        window.addEventListener("online", () => {
            _this.re_timer_count = 0;
            _this.reconnection()
        });
        
    }

    // 断网重连 Reconnection
    reconnection() {

        if(this.ws_connected) return;

        let _this = this;
        this.reconnection_timer = setInterval(() => {
            if(_this.ws_connected || _this.re_timer_count >= 10) {
                clearInterval(_this.reconnection_timer);
            } else {
                console.log('reconnection...');
                _this.re_connect = true;
                _this.connect_ws()
                _this.re_timer_count++;

            }
        },5000)
    }


    start() {
        // 开始发送数据 -- 直到退出会议
        let _this = this;
        this._intervals_get = setInterval(
            _this.get.bind(this),
            2000
        );
        this._intervals_upload = setInterval(
            _this.upload.bind(this),
            500
        )
    }

    join_success(sessionId) { // 加入成功，开始发送 stats

        if(!sessionId) {
            return
        }

        this.sessionId  = sessionId;
        this.data.unshift( this._get_init_data() );

        this.start()

    }

    join_fail() { // 加入失败，发送一条错误的 msg

        let _o = {
            type:0,
            result: 1,
            errorInfo: 'join fail'
        }

        // 直接发送一条数据
        if(this.socket) {
            this.socket.send(_o)
        }
    }
    
    get() { // 收集
        if(
            !this.emedia.useCurrentXService ||
            !this.emedia.useCurrentXService.current || 
            !this.emedia.useCurrentXService.current._cacheStreams
        ) {
            return  // no streams return
        }
        
        let streams = this.emedia.useCurrentXService.current._cacheStreams; // object { streamid: stream }

        let _this = this;
        Object.keys(streams).map(key => {
            _this.push_stats_to_data(streams[key])
        })
    }

    upload() { // 上报

        if(this.data.length == 0) {
            console.warn('upload_stats upload fun -- this.data.length == 0');
            return
        }

        if(!this.socket) { // 如果没有连接成功, 不发数据
            return
        }

        const item =  this.data.shift(); // 发送出去并删除
        
        if(item.counterId == undefined) { // 给每一个 data 添加 counterId、在这里添加才能保持 唯一性
            item.counterId = this.counterId
            this.counterId = this.counterId + 1; // 递增
        } 
        
        this.socket.send(JSON.stringify(item));



        // display html start
        if(item.type == 1) {
            let el = document.querySelector(`#${item.sId}`);

            if(el) {
                let str = '';
                Object.keys(item).map(key => {
                    str += `<div>${key} : ${item[key]}</div>`
                })
                el.innerHTML = str;
            }
        }
        // display html end
    }

    // 事件上报
    upload_event(evt) {
        if(!evt) { 
            return
        }

        let event_obj = this._get_format_event_obj(evt);

        if(!event_obj) {
            return
        }

        this.data.splice(1, 0, event_obj); // send event frist , but init data must array[0]

    }
    // format event
    _get_format_event_obj(evt) {

        let _o = {
            type: 2,
            time: new Date().getTime()
        };

        if(
            typeof evt.event != 'object' && // 有的 会有 event obj ignore
            evt.event != undefined
        ) { // 从另一个地方接收 EventsObservable.js 直接组织好

            return Object.assign(_o, evt)
        }

        let sessionId = this.sessionId;

        if(evt instanceof __event.ICEConnected){

            let obj = this._get_ice_connect_state_obj(evt.webrtc, 2)
            _o = Object.assign( _o, obj );
        } else if(evt instanceof __event.ICEConnectFail){
            let obj = this._get_ice_connect_state_obj(evt.webrtc, 4)
            _o = Object.assign( _o, obj );
        } else if(evt instanceof __event.ICEDisconnected){ //只要ICE断开
            let obj = this._get_ice_connect_state_obj(evt.webrtc, 5)
            _o = Object.assign( _o, obj );
        }else if(evt instanceof __event.PushSuccess){

            if(!evt.hidden) { // hidden: false 为多余的
                return undefined
            }

            let {
                rtcId,
                voff,
                aoff,
                // w: ???
                // h: ???

                type: streamType,
                
            } = evt.stream;

            let obj = {
                event:14,
                sessionId,
                rtcId,
                voff,
                aoff,
                streamType,
                result: 0,
                // vcode: ???
            }

            _o = Object.assign( _o, obj )

        } else if(evt instanceof __event.SubSuccess){


            let {
                rtcId,
                id: sId,
                type: streamType,
                memId: subMemId,
                memName: subMemName,
                
            } = evt.stream;

            let obj = {
                event: 16,
                rtcId,
                sId,
                sessionId,
                result: 0,
                streamType,
                subMemName,
                subMemId
            };

            _o = Object.assign( _o, obj )

        } else if(evt instanceof __event.EnterSuccess){
            let obj = {
                event: 0,
                ip: evt.ip,
                // hopeVCode: ???
            }

            _o = Object.assign( _o, obj )
        } 


        if(_o.event == undefined) { // filter not use
            return undefined
        }
        return _o;
    }

    _get_ice_connect_state_obj(webrtc, state) {
        // adopt webrtc get stream
        let { current } =  this.emedia.useCurrentXService;

        var stream = null;
        
        for(var sid in current._linkedStreams){
            
            if(current._linkedStreams[sid].rtcId == webrtc.getRtcId()){
                stream = current._linkedStreams[sid]
            }
        }

        if(!stream) {
            return {}
        }

        let _o = {
            event:20,
            rtcId: stream.rtcId,
            connState: state,
            isPub: stream.located(),
            sId: stream.id,
            rtcCfg: stream.rtcCfg,
            voff: stream.voff,
            aoff: stream.aoff	
        };

        if(!stream.located()) { // 订阅的字段
            let sub_o = {
                subSId: stream.id,
                subMemName: stream.memName,
                subMemId: stream.memId,
                subVideo: stream.subSVideo,
                subAudio: stream.subSAudio
            }

            _o = Object.assign(_o, sub_o)
        }

        return _o;

    }

    // 停止上报和收集
    stop() {
        clearInterval(this._intervals_get);
        clearInterval(this._intervals_upload);
        
    }





    async push_stats_to_data(stream) { // 将stats 推到 data 队列

        if(!stream._webrtc){
            return
        }
        const stats = await stream._webrtc._rtcPeerConnection.getStats();
        const upload_obj = this._get_format_upload_obj(stats, stream);

        this.data.push(upload_obj);

    }

    _get_init_data() { // 初始化的一条数据
        let _o = {}

        let currentXService = this.emedia.useCurrentXService.current;
        if(!currentXService) {
            return
        }

        let { appkey, version: sdkVersion } = this.emedia.config,
            { confrId, _memberId: memId, memName } = currentXService,
            sessionId  = this.sessionId,
            { browser: deviceInfo, browserVersion: osVersion, isWifi} = this.emedia;

        _o = {
            type: 0,
            counterId: 0,
            appkey,
            confrId,
            memId,	//字符串	上传者的memId，result为0时有效
            memName,
            time: new Date().getTime(),
            joinConfrTime: currentXService.ticket.timestamp, 	//整型	加入会议成功的时间，result为0时有效
            sessionId, //字符串	会议的sessionID，result为0时有效
            networkType:'WIFI',	//字符串	网络类型，包括“WIFI”，“LAN”，“4G”
            sdkOS:'Web',
            sdkVersion,	
            deviceInfo,	
            osVersion,
            result:0	//整型	加入会议的结果，0为成功，其他失败
        }

        return _o
    }
    // 将 stats 和 stream 融合成后端 需要的 核心方法
    _get_format_upload_obj(stats, stream) { // 在 stats 中采集需要的数据
        /**
         * stats： webRtc 的原始数组，包含多种数据
         * stream_info : 流的信息，sId、memId ...
         * sample：https://webrtc.github.io/samples/src/content/peerconnection/constraints/
         */

        // 可以判断sent、received
        let _o = {
            type: 1, 
            time: new Date().getTime(),
            streamType: stream.type,
            sId: stream.id,
            rtcId: stream.rtcId
        };

        if(stream.located()) { // 上行的流
            _o.isPub = true;
            const outbound_stats_obj = this._get_outbound_stats(stats);

            _o = Object.assign(_o, outbound_stats_obj)
        } else { // 下行的流
            _o.isPub = false;
            _o.subMemName = stream.memName;
            _o.subMemId = stream.memId;
            
            const inbound_stats_obj = this._get_inbound_stats(stats);

            _o = Object.assign(_o, inbound_stats_obj)
        }

        // 获取码率 和丢包率
        _o = this._calc_KBps_and_PLR(_o);

        // 将 某些 data 的值转化为 int
        _o = this._set_stats_int(_o);

        return _o
    }
    
    // 上行数据
    _get_outbound_stats(stats) {
        let _o = { };

        stats.forEach(item => {

            if(item.type == 'outbound-rtp') {
                if(item.mediaType == 'audio') {
                    _o.aP = item.packetsSent; 

                    _o.aB = item.bytesSent; // 临时存储
                   
                }
                if(item.mediaType == 'video') {
                    _o.vW = item.frameWidth
                    _o.vH = item.frameHeight
                    _o.vP = item.packetsSent

                    _o.vB = item.bytesSent; // 临时存储
                }
                
            }

            if(item.type == 'remote-inbound-rtp') { // get packetlost
                if(item.kind == 'audio') {
                    _o.aPL = item.packetsLost
                }
                if(item.kind == 'video') {
                    _o.vPL = item.packetsLost
                }
            }

            if(item.type=='media-source') {

                if(item.kind=='audio') {
                    _o.audioInputLevel = item.audioLevel*1000
                }

                if(item.kind == 'video'){
                    _o.vFps = item.framesPerSecond
                }

            }

            if(item.type == 'candidate-pair') {
                _o.RTT = (item.totalRoundTripTime*1000)/item.responsesReceived // totalRoundTripTime: s ---> 换算成ms 
            }

        });

        
        return _o;
    }
    
    // 下行数据
    _get_inbound_stats(stats) {
        let _o = { }
        stats.forEach(item => {

            if(item.type == 'inbound-rtp') {
                if(item.kind == 'audio' || item.id.indexOf('AudioStream')>-1) { //兼容 safiri
                    _o.aP = item.packetsReceived;
                    _o.aPL = item.packetsLost;

                    _o.aB = item.bytesReceived // 临时存储
                }

                if(item.kind == 'video' || item.id.indexOf('VideoStream')>-1) { //兼容 safiri
                    _o.vP = item.packetsReceived;	
                    _o.vPL = item.packetsLost;

                    _o.vB = item.bytesReceived // 临时存储
                }
                
            }

            if(item.type == 'track') {
                if(item.kind == 'video') {
                    _o.vW = item.frameWidth
                    _o.vH = item.frameHeight

                    _o.vFR = item.framesReceived // 暂存
                }

                if(item.kind == 'audio') {
                    _o.audioInputLevel = item.audioLevel*1000 // 貌似一直为 0
                }
            }

            if(item.type == 'candidate-pair') {
                _o.RTT = (item.totalRoundTripTime*1000)/item.responsesReceived // totalRoundTripTime: s ---> 换算成ms 
            }

        });

        return _o;
    }

    // 计算码率和丢包率和下行帧率
    _calc_KBps_and_PLR(upload_obj) {


        let {
            sId,
            aB,
            vB,
            time
        } = upload_obj;

        // 计算码率

        upload_obj.aKBps = this._get_KBps_by_sId(sId, 'audio', aB, time) || 0;
        upload_obj.vKBps = this._get_KBps_by_sId(sId, 'video', vB, time) || 0;

        // 计算丢包率
        let {
            aP,
            aPL,
            vP,
            vPL
        } = upload_obj;

        let aPLR = this._get_PLR_by_sId(sId, 'audio', aP, aPL);
        let vPLR = this._get_PLR_by_sId(sId, 'video', vP, vPL);

        if(aPLR || aPLR == 0) {
            upload_obj.aPLR = aPLR;
        }

        if(vPLR || vPLR == 0) {
            upload_obj.vPLR = vPLR;
        }

        // 下行帧率
        if(!upload_obj.isPub){
            let {
                vFR
            } = upload_obj;

            if(
                this.prev_obj[sId] &&
                this.prev_obj[sId]['video'] &&
                this.prev_obj[sId]['video']['framesReceived']
            ) {
                let prev_time = this.prev_obj[sId].time;
                let prev_vFR = this.prev_obj[sId]['video']['framesReceived'];

                let interval = (time-prev_time)/1000 // 单位：s
                let vFps = (vFR - prev_vFR)/interval;
                if(vFps<0) { vFps = 0 };
                upload_obj.vFps = vFps;
            }

        }
        // 获取网络质量
        // const network_quality = this._network_quality(upload_obj);
        // const network_disconnect = this._network_disconnect(upload_obj);
        const network_quality = this._get_w_quality(upload_obj);

        if(network_quality != 2){

            let event_obj = {
                time: new Date().getTime(),
                event: 4,
                type:2,
                counterId: this.counterId,
                sessionId: this.sessionId,
                rtcId: upload_obj.rtcId,
                sId: upload_obj.sId,
                isPub: upload_obj.isPub,
                streamType: upload_obj.sId,
                aoff: upload_obj.aoff,
                voff: upload_obj.voff,
                subMemName: upload_obj.subMemName,
                subMemId: upload_obj.subMemId
            }

            this.data.push(event_obj); // 上报事件

        }
        
        


        // 触发网络状态检测回调
        if(
            this.emedia.mgr &&
            this.emedia.mgr.onNetworkQuality
        ) {
            let callback = this.emedia.mgr.onNetworkQuality;

            if(typeof callback == 'function') {
                callback(upload_obj.sId, network_quality)
            }
        }

        


        // 存储上一个数据
        this._set_prev_obj(upload_obj);

        // 删除 aB、vB、vFR 发送不需要，只用来计算码率
        delete upload_obj.aB; // audio bytesSent or bytesReceived
        delete upload_obj.vB; // video bytesSent or bytesReceived
        delete upload_obj.vFR; // video framesReceived 
        delete upload_obj.RTT; // RTT 计算网络质量

        return upload_obj
    }

    _set_stats_int(_o) { // 将stats 转换为 整型

        let need_int_keys = [
            'audioInputLevel','vKBps','vFps','vW','vH',
            'vP','vPL','vPLR','aKBps','aP','aPL','aPLR'
        ]
        for (const key in _o) {
            if(need_int_keys.indexOf(key) > -1) {
                _o[key] = Math.round(_o[key])
            }
        }

        return _o
    }
    

    // 通过和上一次的字节比较 计算码率 通过 sId
    _get_KBps_by_sId(sId, kind, bytes, time) {

        if(!sId || !kind || !bytes) {
            return null
        }

        let prev_info = this.prev_obj[sId];

        if(
            !prev_info ||
            !prev_info[kind] ||
            !prev_info[kind]['bytes']
        ) { // 首次或者 没有
            return null
        }

        let { time: prev_time } = prev_info;
        let {
            bytes: prev_bytes
        } = prev_info[kind];

        var interval = parseInt(time - prev_time) // 时间间隔 ms

        var increment = bytes - prev_bytes;

        if(increment < 0) { // 这种情况出现在 开启摄像头， 直接置为 0 
            increment = 0
        }

        var bytes_rate = increment/(interval/1000).toFixed(2) // 以 S 为单位

        return bytes_rate/1000 // KBps
    }

    /**
     * 丢包率
     * 某一时间段内 --  丢包数量/(接收或者发送包数+丢包数量)
     * kind: video or audio
     * end_type: sent or received
     * package_num : total of package sent or receive, 
     * package_loat_num: total of package lost  sent or receive
     * */ 
    _get_PLR_by_sId(sId, kind, packets, packets_lost) {

        if(!sId) {
            return null
        }

        if(
            !kind ||
            !packets || 
            !packets_lost
        ) {
            return 0
        }


        let prev_info = this.prev_obj[sId];

        if(
            !prev_info ||
            !prev_info[kind] ||
            !prev_info[kind]['packets'] ||
            !prev_info[kind]['packets_lost']
        ) {
            return 0
        }

        let {
            packets: prev_packets,
            packets_lost: prev_packets_lost
        } = prev_info[kind];


        let packets_increment = packets-prev_packets,
            packets_lost_increment = packets_lost-prev_packets_lost;

        let packets_lost_rate = packets_lost_increment/(packets_increment+packets_lost_increment);
            packets_lost_rate = Math.round(packets_lost_rate*100)

        return packets_lost_rate;

    }

    
    // 存储上次数据
    _set_prev_obj(_o) {

        let { sId } = _o;
        if(!sId) {
            return
        }
        
        let {
            aB,
            vB,
            time,
            aP,
            aPL,
            vP,
            vPL,
            vFR
        } = _o;



        let audio = {}, video = {};

        if(aB) {
            audio.bytes = aB
        }
        if(aP) {
            audio.packets = aP
        }
        if(aPL || aPL == 0) {
            audio.packets_lost = aPL
        }
        // video
        if(vB) {
            video.bytes = vB
        }
        if(vP) {
            video.packets = vP
        }
        if(vPL || vPL == 0) {
            video.packets_lost = vPL
        }
        if(vFR) {
            video.framesReceived = vFR
        }

        if(
            Object.keys(audio).length == 0 &&
            Object.keys(video).length == 0
        ) { // 都是空对象
            return 
        }

        if(!this.prev_obj[sId]) {
            this.prev_obj[sId] = {}
        }
        this.prev_obj[sId].time = time;

        if(
            Object.keys(audio).length > 0
        ) { 
            this.prev_obj[sId].audio = audio;
        }

        if(
            Object.keys(video).length > 0
        ) { 
            this.prev_obj[sId].video = video;
        }
        
    }


    // 检测网络质量 0 无数据 1 网络差 2 网络好
    _get_w_quality(upload_obj) {
        let {
            RTT,
            aPLR,
            vPLR,
            time,
            vKBps, 
            aKBps,
            sId
        } = upload_obj;

        if(!sId) {
            return 2
        }


        let _this = this;
        // start calc disconnect
        const is_dis = () => {
            let sId_info = _this.network_quality_obj[sId];

            // 断网检测 vKBps, aKBps 同时为零连续一段时间 基本可判断 断网
            if(!sId_info) { // 首次获取数据
                _this.network_quality_obj[sId] = { disconnect: { time } };
                return false
            }

            if(!sId_info['disconnect']) { // 第一次计算这个, 赋值
                _this.network_quality_obj[sId] = { disconnect: { time } };
                return false
            }

            

            let frist_time = sId_info['disconnect'].time;

            let timeout = _this.network_quality_threshold['disconnect'].time;

            if(time - frist_time >= timeout) {// 累计到一定时间
                return true
            }
            
            return false
            // 初始化或者 比较是否累计到了一定时间
            // time 当前时间
            // s --> f_dis_time 流下面的第一次 无数据时间
            // dis_timeout 设定的累计时间
            
        }

        // stop disconnect
        const reset_dis_time = () => {
            let sId_info = _this.network_quality_obj[sId];
            if(!sId_info || !sId_info['disconnect']) return; //从未赋值过，返回

            _this.network_quality_obj[sId]['disconnect'] = undefined;
        } 


        // start calc weak
        // 检测弱网

        const is_weak = (type) => {
            if(
                !type ||
                !time
            ) {
                return false
            }

            let sId_info = _this.network_quality_obj[sId];

            if(!sId_info) { // 第一次接收数据 type、
                _this.network_quality_obj[sId] = { [type]: { time } }

                return false
            }
            if(!sId_info[type]) { // 第一次达到弱网阈值 type
                _this.network_quality_obj[sId][type] = { time }
                return false
            }

            
            
            let frist_time = sId_info[type].time;
            let timeout = _this.network_quality_threshold[type].time;

            // 达到阈值，并且timeout 返回 true
            if(time - frist_time >= timeout) {
                return true
            }
        

            return false;
        }
        // stop weak
        const reset_weak_tiem = (type) => {
            let sId_info = _this.network_quality_obj[sId];

            if(!sId_info || !sId_info[type]) return; //从未赋值过，返回

            _this.network_quality_obj[sId][type] = undefined;
        }
        // good
        
        // vKBps=0,aKBps=0;
        

        if(!vKBps && !aKBps) {
            if(is_dis()){
                return 0
            }
            
            return 2
        }else {
            reset_dis_time();
            
            let checks = ['RTT', 'aPLR', 'vPLR'];// 检测弱网的条件，一个符合则弱网
            let weak = 2;

            for (let index = 0; index < checks.length; index++) {
                const type = checks[index];
                let threshold = this.network_quality_threshold[type].value;

                
                if(upload_obj[type] >= threshold){// 达到阈值，开始计算
                    if(is_weak(type, time)) weak = 1;
                } else {
                    reset_weak_tiem(type)
                }
                
            }

            return weak;
        }

    }

}
export default UploadStats